<script>
export default {
  props: {
    module: Object,
  },
  data: () => ({}),
  computed: {
    news() {
      return this.module.news;
    },
  },
  methods: {
    handlerDialog(value) {
      this.module.show = value;
      if (!value) {
        this.module.adapter.read();
      }
    },
  },
};
</script>
<template>
  <v-dialog
    :value="module.show"
    max-width="920px"
    @input="handlerDialog"
  >
    <v-card v-if="module.show">
      <v-card-title>
        <span class="headline">{{ module.news.title }}</span>
      </v-card-title>
      <v-card-text v-html="module.news.body">
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="handlerDialog(false)">Я ознакомлен</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss">

</style>
